// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nnpp","controls":"styles_controls__hRmMh","charLimit":"styles_charLimit__3SZhV","input":"styles_input__i_H3i","send":"styles_send__-4GOF"};